import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import UserDetails from './userDetails';
import { deleteUser, updateUser } from '../../../../services/clinicPortalServices/userService';
import { getUserDetails, getUserRole } from '../../../../services/common/util';
import Swal from 'sweetalert2';
import moment from 'moment';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { trackRecentView } from '../../../../services/clinicPortalServices/recentViewService';

import RecordDetails from '../../../common/RecordDetails';
export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        let loggedInUserName = '';
        if (getUserDetails()) {
            loggedInUserName = JSON.parse(getUserDetails()).user_name;
        }
        this.state = {
            show: false,
            showPanel: false,
            userId: props.data._id,
            errors: [],
            loggedInUserName: loggedInUserName
        };
    }

    handleShow = () => {
        this.setState({ show: true });
        // Track recent view
        const user = this.props.data;
        if (user) {
            const label = `${user.first_name || ''} ${user.last_name || ''} (${user.user_name || ''})`.trim();
            trackRecentView('user', user._id, label, '/clinic/user');
        }
    };

    handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this user!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const userInfo = {
                    _id: this.state.userId,
                    first_name: this.props.data.first_name,
                    last_name: this.props.data.last_name
                };
                deleteUser(userInfo).then((response) => {
                    this.props.context.componentParent.loadUserGridData();
                });
            }
        });
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit User
        </Tooltip>
    );

    renderTooltipDelete = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Delete User
        </Tooltip>
    );

    renderTooltipActive = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Activate User
        </Tooltip>
    );

    renderTooltipDeactive = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Deactivate User
        </Tooltip>
    );

    handleDeactivate = () => {
        let userInfo = {
            id: this.props.data._id,
            userName: this.props.data.user_name,
            role: this.props.data.role,
            firstName: this.props.data.first_name,
            lastName: this.props.data.last_name,
            password: this.props.data.password,
            email: this.props.data.email,
            mobile: this.props.data.mobile,
            facilityIds: this.props.data.facilityIds,
            companyIds: this.props.data.companyIds,
            require2FA: this.props.data.require2FA,
            is_active: false
        };
        updateUser(userInfo).then((res) => {
            this.props.context.componentParent.loadUserGridData();
        });
    };

    handleActivate = () => {
        let userInfo = {
            id: this.props.data._id,
            userName: this.props.data.user_name,
            role: this.props.data.role,
            firstName: this.props.data.first_name,
            lastName: this.props.data.last_name,
            password: this.props.data.password,
            email: this.props.data.email,
            mobile: this.props.data.mobile,
            facilityIds: this.props.data.facilityIds,
            companyIds: this.props.data.companyIds,
            require2FA: this.props.data.require2FA,
            is_active: true,
            last_logged_in: moment().format('YYYYMMDDHHmmss')
        };
        updateUser(userInfo).then((res) => {
            this.props.context.componentParent.loadUserGridData();
        });
    };

    renderPanel() {
        const d = this.props.data;
        const panelStyles = {
            overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1040 },
            panel: { position: 'fixed', top: 0, right: 0, width: '420px', height: '100vh', background: '#fff', boxShadow: '-4px 0 20px rgba(0,0,0,0.15)', zIndex: 1041, display: 'flex', flexDirection: 'column', overflowY: 'auto' },
            header: { padding: '16px 20px', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f8f9fa' },
            title: { margin: 0, fontSize: '16px', fontWeight: 600, color: '#333' },
            body: { padding: '20px', flex: 1 },
            section: { marginBottom: '20px' },
            sectionTitle: { fontSize: '11px', fontWeight: 700, color: '#888', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '10px', paddingBottom: '6px', borderBottom: '1px solid #eee' },
            dl: { display: 'grid', gridTemplateColumns: '120px 1fr', rowGap: '8px', margin: 0 },
            dt: { fontSize: '13px', color: '#555', fontWeight: 600, paddingRight: '8px' },
            dd: { fontSize: '13px', color: '#222', margin: 0 },
            editBtn: { background: '#0066cc', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px 14px', fontSize: '13px', cursor: 'pointer', marginRight: '8px' },
            closeBtn: { background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#666' }
        };
        const fullName = [d.first_name, d.last_name].filter(Boolean).join(' ');
        const facility = Array.isArray(d.facilityId) ? d.facilityId.map(f => f.facility?.name || f.name || f).join(', ') : (d.facilityId?.name || d.facilityId || '—');
        return ReactDOM.createPortal(
            <>
                <div style={panelStyles.overlay} onClick={() => this.setState({ showPanel: false })} />
                <div style={panelStyles.panel}>
                    <div style={panelStyles.header}>
                        <h5 style={panelStyles.title}>User Details</h5>
                        <div>
                            <button style={panelStyles.editBtn} onClick={() => { this.setState({ showPanel: false }); this.handleShow(); }}>
                                <i className="fas fa-pen" style={{ marginRight: 5 }}></i>Edit
                            </button>
                            <button style={panelStyles.closeBtn} onClick={() => this.setState({ showPanel: false })}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div style={panelStyles.body}>
                        <div style={panelStyles.section}>
                            <div style={panelStyles.sectionTitle}>User Information</div>
                            <dl style={panelStyles.dl}>
                                <dt style={panelStyles.dt}>Username</dt>
                                <dd style={panelStyles.dd}>{d.user_name || '—'}</dd>
                                <dt style={panelStyles.dt}>Name</dt>
                                <dd style={panelStyles.dd}>{fullName || '—'}</dd>
                                <dt style={panelStyles.dt}>Email</dt>
                                <dd style={panelStyles.dd}>{d.email || '—'}</dd>
                                <dt style={panelStyles.dt}>Role</dt>
                                <dd style={panelStyles.dd}>{d.role || '—'}</dd>
                                <dt style={panelStyles.dt}>Mobile</dt>
                                <dd style={panelStyles.dd}>{d.mobile || '—'}</dd>
                                <dt style={panelStyles.dt}>Status</dt>
                                <dd style={panelStyles.dd}>
                                    <span style={{ color: d.is_active ? '#28a745' : '#dc3545', fontWeight: 600 }}>
                                        {d.is_active ? 'Active' : 'Inactive'}
                                    </span>
                                </dd>
                                <dt style={panelStyles.dt}>Facility</dt>
                                <dd style={panelStyles.dd}>{facility}</dd>
                            </dl>
                        </div>
                        {!/salesadmin|salesperson|audit|customerserviceuser/.test(getUserRole().toLowerCase()) &&
                         !(d.role === 'SuperAdmin' && /^admin/.test(getUserRole().toLowerCase())) && (
                            <div style={panelStyles.section}>
                                <div style={panelStyles.sectionTitle}>Actions</div>
                                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                    {d.is_active ? (
                                        <button style={{ ...panelStyles.editBtn, background: '#e67e22' }} onClick={() => { this.setState({ showPanel: false }); this.handleDeactivate(); }}>
                                            <i className="fas fa-lock" style={{ marginRight: 5 }}></i>Deactivate
                                        </button>
                                    ) : (
                                        <button style={{ ...panelStyles.editBtn, background: '#28a745' }} onClick={() => { this.setState({ showPanel: false }); this.handleActivate(); }}>
                                            <i className="fas fa-lock-open" style={{ marginRight: 5 }}></i>Activate
                                        </button>
                                    )}
                                    {!d.is_active && (
                                        <button style={{ ...panelStyles.editBtn, background: '#dc3545' }} onClick={() => { this.setState({ showPanel: false }); this.handleDelete(); }}>
                                            <i className="fas fa-trash" style={{ marginRight: 5 }}></i>Delete
                                        </button>
                                    )}
                                </div>
                            </div>
                        )}
                    
                        <RecordDetails data={d} exclude={['email', 'facilityId', 'first_name', 'is_active', 'last_name', 'mobile', 'role', 'user_name', 'results', 'password', 'token', 'resetPasswordToken', 'refreshToken']} />
                    </div>
                </div>
            </>,
            document.body
        );
    }

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">View User</Tooltip>}>
                    <button onClick={() => this.setState({ showPanel: true })} className="edit-order-btn">
                        <i className="fas fa-eye"></i>
                    </button>
                </OverlayTrigger>
                {this.state.showPanel && this.renderPanel()}
                {!(this.props.data.role === 'SuperAdmin' && /^admin/.test(getUserRole().toLowerCase())) && (
                    <div>
                        {!/salesadmin/.test(getUserRole().toLowerCase()) && (
                            <OverlayTrigger
                                placement="top"
                                delay={{ show: 50, hide: 100 }}
                                overlay={this.renderTooltipEdit}
                            >
                                <button onClick={this.handleShow} className="edit-order-btn">
                                    <i className="fas fa-pen"></i>
                                </button>
                            </OverlayTrigger>
                        )}
                        {/salesadmin/.test(getUserRole().toLowerCase()) && this.props.data.role === 'SalesPerson' && (
                            <OverlayTrigger
                                placement="top"
                                delay={{ show: 50, hide: 100 }}
                                overlay={this.renderTooltipEdit}
                            >
                                <button onClick={this.handleShow} className="edit-order-btn">
                                    <i className="fas fa-pen"></i>
                                </button>
                            </OverlayTrigger>
                        )}
                        {!/salesadmin/.test(getUserRole().toLowerCase()) && this.props.data.is_active && (
                            <OverlayTrigger
                                placement="top"
                                delay={{ show: 50, hide: 100 }}
                                overlay={this.renderTooltipDeactive}
                            >
                                <button onClick={this.handleDeactivate} className="edit-order-btn">
                                    <i className="fas fa-lock"></i>
                                </button>
                            </OverlayTrigger>
                        )}
                        {!/salesadmin/.test(getUserRole().toLowerCase()) && !this.props.data.is_active && (
                            <OverlayTrigger
                                placement="top"
                                delay={{ show: 50, hide: 100 }}
                                overlay={this.renderTooltipActive}
                            >
                                <button onClick={this.handleActivate} className="edit-order-btn">
                                    <i className="fas fa-lock-open"></i>
                                </button>
                            </OverlayTrigger>
                        )}
                        {!/salesadmin/.test(getUserRole().toLowerCase()) &&
                            this.props.context.componentParent.state.isArchived && (
                            <OverlayTrigger
                                placement="top"
                                delay={{ show: 50, hide: 100 }}
                                overlay={this.renderTooltipDelete}
                            >
                                <button onClick={this.handleDelete} className="edit-order-btn">
                                    <i className="fas fa-trash"></i>
                                </button>
                            </OverlayTrigger>
                        )}
                    </div>
                )}
                <ModalStyled
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Update User Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <UserDetails
                            userId={this.state.userId}
                            context={this.props.context}
                            handleClose={this.handleClose}
                        />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
